import { render, staticRenderFns } from "./previewInvesResult.vue?vue&type=template&id=60abb681&scoped=true&"
import script from "./previewInvesResult.vue?vue&type=script&lang=js&"
export * from "./previewInvesResult.vue?vue&type=script&lang=js&"
import style0 from "./previewInvesResult.vue?vue&type=style&index=0&id=60abb681&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60abb681",
  null
  
)

export default component.exports